/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useDataFetchIndicator } from '..';
import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.IQ11TokenResponse,
  (_params: vp.LinkPushToCardRequest) => void,
  () => void,
  (_params: vp.LinkPushToCardRequest) => Promise<vp.IQ11TokenResponse>,
];

function usePostLinkCreditCard({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [params, setParams] = useState<vp.LinkPushToCardRequest>();
  const [response, setResponse] = useState<vp.IQ11TokenResponse>({
    Success: false,
    ErrorMessage: '',
    Token: '',
  });

  useEffect(() => {
    const sendRequest = async (requestParams: vp.LinkPushToCardRequest) => {
      setDataFetchingInfo(true, `${t('addingDebitCard')}`, 'fullScreen');
      const res = await api.postLinkPushToCard(requestParams, source);

      setResponse(res);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.LinkPushToCardRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Token: '',
      });
      setSendRequest(false);
    },
    (_params: vp.LinkPushToCardRequest) => {
      const res = api.postLinkPushToCard(_params, source);
      return res;
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostLinkCreditCard);
